import * as React from 'react';

const styles = require('./logo_pik.css');

export class LogoPIK extends React.PureComponent<object, object> {
  public render() {
    return <a href="#" className={styles['link']} />;
  }
}
